// eslint-disable-next-line no-restricted-imports
import {
    Dialog as OgDialog,
    DialogProps as OgDialogProps,
} from '@mui/material';
// eslint-disable-next-line no-restricted-imports
import { TransitionProps } from '@mui/material/transitions';
import React, { ForwardedRef, PropsWithChildren } from 'react';

class DialogOpenTracker extends React.Component<
    PropsWithChildren<{ onOpen?: () => void; onClose?: () => void }>
> {
    componentDidMount() {
        this.props?.onOpen?.();
    }

    componentWillUnmount() {
        this.props?.onClose?.();
    }

    render() {
        return <>{this.props.children}</>;
    }
}

export interface DialogProps extends OgDialogProps {
    onOpen?: () => void;
    onUnmount?: () => void; // Overridden so that it will happen on unmount which always occurs
}

export const Dialog = React.forwardRef(function AccessibleDialog(
    {
        children,
        onOpen,
        onUnmount,
        open,
        PaperProps,
        TransitionProps,
        ...otherProps
    }: DialogProps,
    ref: ForwardedRef<HTMLDivElement>
) {
    return (
        <OgDialog
            ref={ref}
            open={open}
            PaperProps={{ ...PaperProps, tabIndex: -1, 'aria-modal': true }}
            TransitionProps={
                {
                    ...TransitionProps,
                    role: undefined,
                } as unknown as TransitionProps
            }
            {...otherProps}
        >
            <DialogOpenTracker onOpen={onOpen} onClose={onUnmount}>
                {children}
            </DialogOpenTracker>
        </OgDialog>
    );
});
